<template>
  <d2-container>
    <top-line :message="pageTitle" :iconclass="'fa fa-sitemap'"></top-line>

    <el-row class="pagebody">
      <!-- 操作栏 -->
      <el-row class="filter-bar">
        <el-card shadow="never">
          <el-form :inline="true" size="small">
            <el-form-item>
              <el-button
                type="success"
                icon="el-icon-plus"
                plain
                @click="handleCreate"
              >
                新增菜单
              </el-button>
            </el-form-item>
          </el-form>
        </el-card>
      </el-row>

      <!-- 树形表格 -->
      <el-row class="main-table">
        <el-table
          :data="tableData"
          border
          stripe
          style="width: 100%"
          v-loading="loading"
          row-key="id"
          :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
        >
          <!-- <el-table-column type="index" label="序号" width="60" align="center" />

          <el-table-column prop="id" label="菜单ID" width="200" show-overflow-tooltip /> -->

          <el-table-column prop="name" label="菜单名称" min-width="160">
            <template v-slot="scope">
              <span :style="{ fontWeight: scope.row.type === 0 ? 'bold' : 'normal' }">
                {{ scope.row.name }}
              </span>
            </template>
          </el-table-column>

          <el-table-column prop="path" label="路由路径" min-width="150" show-overflow-tooltip />

          <!-- <el-table-column prop="displayOrder" label="排序" width="80" align="center" /> -->

          <el-table-column label="菜单类型" width="100">
            <template v-slot="scope">
              <el-tag :type="getTypeTag(scope.row.type)">
                {{ formatType(scope.row.type) }}
              </el-tag>
            </template>
          </el-table-column>

          <el-table-column label="显示状态" width="100">
            <template v-slot="scope">
              <el-tag :type="scope.row.visible === 0 ? 'success' : 'info'">
                {{ scope.row.visible === 0 ? '显示' : '隐藏' }}
              </el-tag>
            </template>
          </el-table-column>

          <el-table-column label="状态" width="100">
            <template v-slot="scope">
              <el-tag :type="scope.row.status === 0 ? 'success' : 'danger'">
                {{ scope.row.status === 0 ? '启用' : '禁用' }}
              </el-tag>
            </template>
          </el-table-column>

          <!-- 操作列 -->
          <el-table-column fixed="right" label="操作" width="200" align="center">
            <template v-slot="scope">
              <el-button type="text" size="mini" @click="handleEdit(scope.row)">
                编辑
              </el-button>
              <el-button type="text" size="mini" @click="handleDelete(scope.row)">
                删除
              </el-button>
              <el-button
                v-if="scope.row.type === 0"
                type="text"
                size="mini"
                @click="handleCreateChild(scope.row)"
              >
                添加子菜单
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
    </el-row>

    <!-- 新增/编辑弹窗 -->
    <create-menu ref="createMenu" @success="loadMenuTree"  />
    <edit-menu ref="editMenu" @success="loadMenuTree"  />
  </d2-container>
</template>

<script>
import topLine from '@/components/save-common/topLine.vue';
import CreateMenu from '../menu/CreateMenu.vue';
import EditMenu from '../menu/EditMenu.vue';

export default {
  name: 'MenuTree',
  components: {
    topLine,
    CreateMenu,
    EditMenu
  },
  data() {
    return {
      pageTitle: '菜单管理',
      loading: false,
      tableData: [],
      tableDataApi: '/api-30216/api/menu/tree' // GET 请求地址
    };
  },
  mounted() {
    this.loadMenuTree();
  },
  methods: {
    // 加载菜单树
    loadMenuTree() {
      this.loading = true;
      this.$axios
        .get(this.tableDataApi)
        .then((res) => {
          // 假设后端返回 { code: 200, data: [...] }
          this.tableData = Array.isArray(res.data) ? res.data : [];
        })
        .catch((err) => {
          console.error('获取菜单树失败：', err);
          this.$message.error('菜单数据加载失败');
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 格式化菜单类型
    formatType(val) {
      const map = {  1: '目录', 2: '菜单', 3: '按钮'};
      return map[val] || '未知';
    },
    getTypeTag(val) {
      const tagMap = {
        1: 'primary',  // 目录 - 蓝色
        2: 'success',  // 菜单 - 绿色
        3: 'info'      // 按钮 - 灰色
      };
      return tagMap[val] || 'warning'; // 未知类型用 warning（黄色）
    },

    // 新增根菜单
    handleCreate() {
      if (this.$refs.createMenu && typeof this.$refs.createMenu.openDialog === 'function') {
        this.$refs.createMenu.openDialog();
      }
    },

    // 新增子菜单
    handleCreateChild(parent) {
      if (this.$refs.createMenu && typeof this.$refs.createMenu.openDialog === 'function') {
        this.$refs.createMenu.openDialog(parent.id); // 传入父级ID
      }
    },

    // 编辑菜单
    handleEdit(row) {
      if (this.$refs.editMenu && typeof this.$refs.editMenu.openDialog === 'function') {
        this.$refs.editMenu.openDialog({ ...row });
      }
    },

    // 删除菜单
    handleDelete(row) {
      this.$confirm(`确定要删除菜单 “[${row.name}]” 及其所有子菜单吗？`, '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          // 调用删除接口
          this.$axios
            .delete(`/api-30216/api/menu/${row.id}`)
            .then((res) => {
              if (res.code === 200) {
                this.$message.success('删除成功');
                this.loadMenuTree(); // 刷新
              } else {
                this.$message.error(res.message || '删除失败');
              }
            })
            .catch((err) => {
              console.error('删除失败：', err);
              this.$message.error('删除请求失败');
            });
        })
        .catch(() => {
          this.$message.info('已取消删除');
        });
    }
  }
};
</script>

<style scoped lang="scss">
.pagebody {
  margin-top: 20px;
  margin-left: 20px;
}
.filter-bar {
  margin-bottom: 10px;
}
.main-table {
  margin-top: 10px;
}
</style>